import { Datagrid, InfiniteList, NumberField, TextField } from 'react-admin'
import ProductFilters from './ProductFilters'
import ProductListActions from './ProductListActions'

const ProductList = () => {
  return (
    <InfiniteList filters={ProductFilters} actions={<ProductListActions />} sort={{field: "productName", order: "ASC"}} >
      <Datagrid rowClick="edit">
        <TextField source='productName' label="resources.products.productName" sortable={false} />
        <TextField whiteSpace={"pre-line"} source='description' label="resources.products.description" sortable={false} />
        <NumberField source='price' options={{ style: 'currency', currency: 'EUR' }} label="resources.products.price" sortable={false} />
        <NumberField source="tax_in_percent" label="resources.common.tax_in_percent" options={{ style: 'percent' }} sortable={false} />
      </Datagrid>
    </InfiniteList>
  )
}

export default ProductList